export const favouritesListParser = data => (data.payload && data.payload.itemList
  ? data.payload.itemList.split(',') : [])



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/actions/favouritesListParser.js